import { useAuth } from '@/context';
import { useDataLayerOneTrustConfirmationEvent } from '@/hooks';
import React from 'react';
import TagManager from 'react-gtm-module';
import { useStorageState } from 'react-storage-hooks';

export const useLogout = () => {
  const { lastPageBeforeLogout } = useAuth();
  const dataLayerRef = React.useRef({});
  const [isLoggedOut, setIsLoggedOut] = useStorageState(
    sessionStorage,
    'DATALAYER.IS_LOGGED_OUT',
    false,
  );

  React.useEffect(() => {
    dataLayerRef.current = {
      event: 'trackEvent-accessEngagement',
      event_name: 'logout',
      eventCategory: 'engagement',
      eventAction: 'logout',
      eventlabel: lastPageBeforeLogout,
      previous_page_url: lastPageBeforeLogout,
    };
  }, [lastPageBeforeLogout]);

  useDataLayerOneTrustConfirmationEvent(
    (_, unsubscribe = () => {}) => {
      if (isLoggedOut) {
        TagManager.dataLayer({ dataLayer: dataLayerRef.current });
        setIsLoggedOut(false);
      }

      unsubscribe();
    },
    { fireOnMount: true },
  );
};
